import { React, useState } from 'react';
import { useUserContext } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Image, Form, Button, Stack, Spinner } from 'react-bootstrap';
import * as api from 'services/api';
import './Login.css';
import { jwtDecode } from "jwt-decode";
import { useConfig } from 'contexts/ConfigContext';
import { useTranslation } from 'react-i18next';

export function Login() {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
  const { configData } = useConfig();
  const navigate  = useNavigate ();
    const { updateUser } = useUserContext();
  const [user, setUser] = useState({ 
    username: '', 
    password: '', 
    showPassword: false 
  });
  const [error, setError] = useState('');

  const handleUsernameChange = (event) => {
    setUser({ ...user, username: event.target.value });
  };

  const handlePasswordChange = (event) => {
    setUser({ ...user, password: event.target.value });
  };

  const handleTogglePasswordVisibility = () => {
    setUser({ ...user, showPassword: !user.showPassword });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
      setLoading(true);
    try {
      if (!user.username) {
          setError(t('userRequired'));
        return;
      }
    
      if (!user.password) {
          setError(t('passwordRequired'));
        return;
        }

        

      const response = await api.login(user.username, user.password);

        console.log(response.data);
        if (response.status === 202) { //2FA
            navigate('/login2fa', {
                state: {
                    twoFAToken: response.data.twoFAToken,
                },
            });
        } else if (response.data.status === "send_failed") { //2FA
            setError(t('2FAsendFailed'));
        } else if (response.status === 200) {//OK
            setError('');      
            localStorage.setItem('token', response.data.token);   
            const decoded = jwtDecode(response.data.token);
            const user = await api.getUserAccount();  
            const responseLC = await api.getLastConnection(user.data.personId);
            const userData = { ...user.data, controlCentreId: decoded.ControlCentreId, lastConnection: responseLC.data };   
            updateUser(userData);
            navigate('/home');
          } else {
            setError(t(response.data.message));
          }
    } catch (error) {
      setError('Error en la conexión');
    } finally {
        setLoading(false);
    }
  };

    const currentYear = new Date().getFullYear();

  return (
    <Container fluid className="Login" style={{ height: '100vh' }}>
      <Row className="justify-content-center align-items-center h-100">
        <Col xs={12} sm={8} md={6} lg={4} className="text-center">
          <Image src="./images/tunstall-logo.png" fluid style={{ maxHeight: 'auto', maxWidth: '180px' }} />
          <h5 className="mt-2">{configData.companyName}</h5>
          <Form className="mt-5 mx-auto" style={{ maxWidth: '340px' }} onSubmit={handleLogin}>
            <Form.Group className="mb-3" controlId="user.name">
              <Stack direction="vertical">
                <Form.Label className="small text-start">{t('user')}</Form.Label>
                <Form.Control type="text" placeholder={t('user')} className="form-control form-control-lg bg-light" style={{ maxWidth: '100%' }} value={user.username} onChange={handleUsernameChange} autoComplete="username"/>
              </Stack>
            </Form.Group>
            <Form.Group className="mb-3" controlId="user.password">
                <Stack direction="vertical">
                  <Form.Label className="small text-start">{t('password')}</Form.Label>
                  <Stack direction="horizontal" gap="1" className="Login__passwordContainer">
                    <Form.Control type={user.showPassword ? 'text' : 'password'} placeholder="********" className="form-control form-control-lg bg-light" value={user.password} onChange={handlePasswordChange} />
                    <Stack className="Login__passwordIcon">
                      <Image src="./icons/eye.svg" onClick={handleTogglePasswordVisibility} />
                    </Stack>
                  </Stack>
                </Stack>
            </Form.Group>
            <Stack direction="horizontal" className="justify-content-start">
              {error && <p className="text-danger fw-semibold">{error}</p>}
            </Stack>
            
            <Button type="submit" variant="dark" size="lg" className="mt-3">
                {loading ? (
                    <Spinner animation="border" variant="secondary" size="sm" />
                ) : ( t('login') )}
            </Button>
            
            
          </Form>
          <hr className="mt-4 border-1 mx-auto" style={{ maxWidth: '30%' }} />
          <p className="mt-4">Copyright &copy; Tunstall {currentYear}</p>
        </Col>
      </Row>
    </Container>
  );
}
